module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAsElEQVR4AWOgCzijLnNHVuaOiuJdI/37rk73jAzuqqnckZG+Iy/H0MGAjKDgoYzsW0mlD9ZOH2xd3xtbfbBx/mDv9lZG9a2YPHYN71R13xtZfXDxBqr4uWX7BzO7Dxb2H2xc3grL/EcFUA13pKU+OLi/U9J+p6oHFP0+d+FbCSWQfhFZ7DYA3QqUAyEJxR/LVn4MiXrDJ/FWWPatuAJ2Df+JBjAdHcQiwhoGv5MGJwAAS6rH0P9v7uMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/AB.png
// module id = 1066
// module chunks = 0